module.exports = __webpack_public_path__ + "static/img/game-logo-km.eb1440d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-km.png
// module id = BJwC
// module chunks = 0 1 2 3 4 5 6